import * as jsxRuntime from "/builds/morressier/publishing-engine/publishing-engine/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment